import React from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Divider,
  Grid,
  Stack,
} from "@mui/material";

// Action Badge component for common styling
const StatCard = ({ label, value, color, isLast }) => (
  <Box
    sx={{
      flex: 1, // Har box barabar jagah lega
      p: 1.5,
      textAlign: "center",
      borderRight: isLast ? "none" : "1px solid #eef2f2", // Divider look
      minWidth: "100px",
    }}
  >
    <Typography
      variant="caption"
      sx={{
        fontWeight: 700,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        fontSize: "0.65rem",
        letterSpacing: "0.5px",
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        fontWeight: 800,
        color: color,
        fontSize: "1rem",
      }}
    >
      ₹{value || "0.00"}
    </Typography>
  </Box>
);

const ViewPayouReportsModal = ({ data }) => {
  if (!data || data.length === 0)
    return (
      <Box sx={{ p: 5, textAlign: "center" }}>
        <Typography variant="h6" color="text.secondary">
          No Detailed Data Found
        </Typography>
      </Box>
    );

  return (
    <Box sx={{ p: 2, bgcolor: "#f8fbfc" }}>
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 800, color: "#205964" }}
      >
        Transaction Breakdown
      </Typography>

      {/* --- LEVEL 1: MULTIPLE REQUESTS LOOP --- */}
      {data.map((request) => (
        <Paper
          key={request.pay_req_id}
          elevation={0}
          sx={{
            mb: 5,
            borderRadius: "20px",
            border: "1px solid #e0e6e6",
            overflow: "hidden",
            bgcolor: "#fff",
          }}
        >
          {/* Elegant Gradient Header */}
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #347B89 0%, #205964 100%)",
              color: "white",
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 800 }}>
                  Request ID #{request.pay_req_id}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ opacity: 0.9, fontWeight: 500 }}
                >
                  Srv Prof ID: {request.srv_prof_id} 
                </Typography>
              </Box>
              {/* <Chip
                label={request.payment_status === 2 ? "APPROVED" : "PENDING"}
                sx={{
                  bgcolor: request.payment_status === 2 ? "#C8E6C9" : "#FFF9C4",
                  color: request.payment_status === 2 ? "#1B5E20" : "#F57F17",
                  fontWeight: 900,
                  fontSize: "0.7rem",
                  px: 1,
                }}
              /> */}
            </Stack>
          </Box>

          <Box sx={{ p: 3 }}>
            {/* Level 2: Financial Grid */}
            <Box
              sx={{
                display: "flex",
                bgcolor: "#fff",
                borderBottom: "none",
                overflowX: "auto",
                mb: 1.5,
              }}
            >
              <StatCard
                label="TOTAL REQUESTED COST"
             
                value={request.total_requeststed_amount}
                color="#1976D2"
              />
              <StatCard
                label=" TOTAL PROF. COST"
                value={request.events?.[0]?.total_prof_cost}
                color="#205964"
              />
              <StatCard
                label="TDS (10%)"
                value={request.TDS_deducted_amount}
                color="#D32F2F"
              />
              <StatCard
                label="CONVEYANCE"
                value={request.convenience}
                color="#616161"
              />
              <StatCard
                label="APPRONE"
                value={request.approne_charges}
                color="#347B89"
              />
              <StatCard
                label="POLICE VERIF."
                value={request.police_verification_charges}
                color="#347B89"
              />
              <StatCard
                label="NET PAYABLE"
                value={request.net_amount}
                color="#2E7D32"
                isLast
              />
            </Box>
            <Divider sx={{ mb: 4 }}>
              <Chip
                label="Events Under This Request"
                size="small"
                sx={{ fontWeight: 700, bgcolor: "#f0f4f4" }}
              />
            </Divider>

            {/* --- LEVEL 3: EVENTS LOOP --- */}
            {request.events?.map((event) => (
              <Box
                key={event.pay_req_eve_id}
                sx={{
                  mb: 3,
                  borderRadius: "12px",
                  border: "1px solid #eaeeee",
                  overflow: "hidden",
                  transition: "0.2s",
                  "&:hover": { borderColor: "#347B89" },
                }}
              >
                {/* Event Compact Header */}
                <Box
                  sx={{
                    p: 1.5,
                    bgcolor: "#f9fbfb",
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #eaeeee",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 700, color: "#444" }}
                  >
                    Event Code:{" "}
                    <span style={{ color: "#347B89" }}>{event.event_code}</span>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 800, color: "#205964" }}
                  >
                    ₹{event.total_prof_cost}
                  </Typography>
                </Box>

                {/* --- LEVEL 4: SESSIONS TABLE --- */}
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.7rem",
                            color: "#888",
                          }}
                        >
                          PROFESSIONAL NAME
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.7rem",
                            color: "#888",
                          }}
                        >
                          DATE
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.7rem",
                            color: "#888",
                          }}
                        >
                          TIMING
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 700,
                            fontSize: "0.7rem",
                            color: "#888",
                          }}
                          align="right"
                        >
                          SESSIONS
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {event.revalidated_session_ids?.map((session) => (
                        <TableRow
                          key={session.session_id}
                          hover
                          sx={{ "&:last-child td": { border: 0 } }}
                        >
                          <TableCell
                            sx={{ fontSize: "0.8rem", fontWeight: 600 }}
                          >
                            {request.prof_name || "N/A"}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.8rem" }}>
                            {session.actual_StartDate_Time}
                          </TableCell>
                          <TableCell
                            sx={{ fontSize: "0.8rem", color: "text.secondary" }}
                          >
                            {session.start_time} - {session.end_time}
                          </TableCell>

                          <TableCell
                            align="right"
                            sx={{ fontSize: "0.8rem", fontWeight: 700 }}
                          >
                            1
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Event Footer Metadata */}
                <Box
                  sx={{
                    p: 1,
                    px: 2,
                    bgcolor: "#fff",
                    borderTop: "1px dashed #eee",
                  }}
                >
                  <Typography variant="caption" color="text.disabled">
                    Duration: {event.service_start_date?.split("T")[0]} to{" "}
                    {event.service_end_date?.split("T")[0]} • Total Sessions:{" "}
                    {event.session_count}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Paper>
      ))}
    </Box>
  );
};

export default ViewPayouReportsModal;
